/* eslint-disable import/no-extraneous-dependencies */
import { Typography } from '@mui/material';
import { decode } from 'jsonwebtoken-esm';
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoDark from '../../../../assets/LogoDark.svg';
import GlobalContext from '../../../../context/GlobalContext';
import LoginAPI from '../../../../services/API/others/LoginAPI';
import { verifyEmail } from '../../../../services/auxiliaryFunctions/functions';
import MainButton from '../../../components/singleComponents/buttons/MainButton';
import {
  ButtonTextStyled,
  ContainerInputStyled,
  IconStyled,
  InputStyled,
  RootStyled,
} from './LoginSuperAdmin.styles';

export function LoginSuperAdmin() {
  const navigate = useNavigate();
  const { setUserData } = useContext(GlobalContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  function handleSubmitLogin() {
    const submit = () => {
      if (verifyEmail) {
        const data = {
          auth: {
            email,
            password,
          },
        };

        LoginAPI.postLogin(data).then((res) => {
          const { token } = res.data;
          if (token) {
            const { user } = decode(token);
            localStorage.setItem('token', JSON.stringify(token));
            localStorage.setItem('user', JSON.stringify(user));
            setUserData(user);
            navigate('/home');
          } else {
            setErrorSubmit(true);
            navigate('/admin');
          }
        });
      }
    };
    submit();
  }

  return (
    <RootStyled>
      <img src={LogoDark} alt="Logo da SIOON" />
      <ContainerInputStyled>
        <Typography variant="h2">Login</Typography>
        <InputStyled
          fullWidth
          placeholder="E-mail"
          value={email}
          error={errorSubmit}
          onChange={({ target }) => {
            setErrorSubmit(false);
            setEmail(target.value);
          }}
        >
          {' '}
        </InputStyled>
        <InputStyled
          fullWidth
          placeholder="Senha"
          type={showPassword ? 'text' : 'password'}
          value={password}
          error={errorSubmit}
          onChange={({ target }) => {
            setErrorSubmit(false);
            setPassword(target.value);
          }}
          endAdornment={
            password && (
              <IconStyled onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? 'visibility' : 'visibility_off'}
              </IconStyled>
            )
          }
        >
          {' '}
        </InputStyled>
        <MainButton
          onClick={() => {
            handleSubmitLogin();
          }}
        >
          <ButtonTextStyled variant="h3">Entrar</ButtonTextStyled>
        </MainButton>
      </ContainerInputStyled>
    </RootStyled>
  );
}
